import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRitualWaveTop = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: 1200,
	height: 100,
	viewBox: "0 0 1200 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1200 0C1009.09 65.1652 807.865 100 600 100C392.135 100 190.91 65.1652 0 0H1200Z",
		fill: "currentColor"
	})
});
export default SvgRitualWaveTop;
